<template>
  <div class="box">
    <div class="teacherworkattendance_box">
      <div class="twa_num">
        <div class="twa_num_l">
          <div>
            考勤次数:
            <span>{{WorkAttendanceNum.attenceTotleNum}}</span>
          </div>
          <div>
            未开始:
            <span>{{WorkAttendanceNum.attenceUnstartNum}}</span>
          </div>
          <div>
            进行中:
            <span>{{WorkAttendanceNum.attencestartNum}}</span>
          </div>
          <div>
            已结束:
            <span>{{WorkAttendanceNum.attenceOverNum}}</span>
          </div>
        </div>
        <div class="twa_num_r">
          <div>
            历史平均签到率:
            <span>{{WorkAttendanceNum.attenceProbability}}%</span>
          </div>
        </div>
      </div>
      <div class="search_box">
        <div class="calendar_search_auto">
          <div class="picker">
            <el-date-picker
              class="el_calendar1"
              v-model="value1"
              @change="getDate1()"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
            ></el-date-picker>
            <span class="heng"></span>
            <el-date-picker
              class="el_calendar2"
              v-model="value2"
              @change="getDate1()"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
            ></el-date-picker>
          </div>

          <el-select  clearable v-model="value6"  @change="stateChange" class="select1" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="btn_search" @click="queryList">查询</el-button>
          <el-button class="btn_work_attendance" @click="clickPush">发起签到</el-button>
        </div>
      </div>

      <el-dialog
        :visible.sync="dialogTableVisible"
        :modal-append-to-body="false"
        @open="open"
        :title="viewDetailobj.title+'签到情况'"
        class="dialog_1"
      >
        <el-button type="primary">
          <span>
            {{viewDetailobj.attencePepleNum}} /
            <i>{{viewDetailobj.attenceAmountPepleNum}}</i>
          </span>
        </el-button>
        <input
          type="text"
          class="search"
          @keyup="getSearchList"
          v-model="searchId"
          placeholder="请输入姓名或学号"
        />
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="'已签到 ('+numTrue+')'" name="second">
            <ul>
              <li class="dialog_1_ul_li">
                <span>姓名</span>
                <span class="span_r">学号</span>
              </li>
             
             <div class="sarch_ul">
                <li v-for="(item,index) in viewDetailList" v-if="item.chickIn">
                  <span>{{item.studentName}}</span>
                  <span class="span_r">{{item.studentNumber}}</span>
                </li>
              </div>
            </ul>
          </el-tab-pane>
          <el-tab-pane :label="'未签到 ('+numFalse+')'" name="first">
            <ul >
              <li class="dialog_1_ul_li">
                <span>姓名</span>
                <span class="span_r">学号</span>
              </li>
              
              <div class="sarch_ul">
                 <li v-for="(item,index) in viewDetailList" v-if="!item.chickIn">
                   <span>{{item.studentName}}</span>
                   <span class="span_r">{{item.studentNumber}}</span>
                 </li>
              </div>
            </ul>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <el-dialog
        :visible.sync="dialogTableVisible2"
        :modal-append-to-body="false"
        title="发起考勤"
        class="dialog_2"
      >
        <div class="laber_box">
          <label for="date">日期</label>
          <el-date-picker
            class="laber_box_date"
            id="date"
            type="dates"
            :picker-options="pickerOptions0"
            @change="getTwkDataList"
            v-model="value3"
            value-format="yyyy-MM-dd"
            placeholder="选择一个或多个日期"
          ></el-date-picker>
        </div>

        <div class="laber_box" >
          <label for="timer">签到时间</label>
            <el-time-picker
              is-range
              key="bufuyong1"
              value-format="HH:mm:ss"
              v-model="value9"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围">
            </el-time-picker>
            <p class="laber_p">可以手动输入时间</p>
        </div>

        <div class="button_box">
          <el-button type="primary" @click="cancel">取消</el-button>
          <el-button type="primary" @click="addData">确定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑功能的弹出框 -->
      <el-dialog
        :visible.sync="dialogTableVisible3"
        :modal-append-to-body="false"
        title="编辑考勤"
        class="dialog_3"
      >
        <div class="laber_box" v-if="reviseDataobj.state==1">
          <label for="date">日期</label>
          <el-date-picker
            class="laber_box_date"
            id="date"
            type="date"
            :picker-options="pickerOptions0"
            v-model="DisableValue"
            value-format="yyyy-MM-dd"
            placeholder="选择一个或多个日期"
           
          ></el-date-picker>
        </div>
        <div class="laber_box" v-if="reviseDataobj.state==0">
          <label for="date">日期</label>
          <el-date-picker
            class="laber_box_date"
            id="date"
            type="date"
             :picker-options="pickerOptions0"
            v-model="DisableValue"
            value-format="yyyy-MM-dd"
            placeholder="选择一个或多个日期"
            :disabled="true"
          ></el-date-picker>
        </div>

        <div class="laber_box">
          <label for="timer">签到时间</label>

          <el-time-select
            v-if="reviseDataobj.state==0"
            v-model="value7"
            value-format="HH:mm:ss"
            class="el_calendar1"
            @change="getDate3()"
            :disabled="true"
            placeholder="任意时间点"
            :picker-options="{     
           start: startT,
           step: '00:01',
           end: '23:59' }"
          ></el-time-select>
          <el-time-select
            v-if="reviseDataobj.state==1"
            v-model="value7"
            value-format="HH:mm:ss"
            class="el_calendar1"
            @change="getDate3()"
            placeholder="任意时间点"
            :picker-options="{     
           start: '00:00',
           step: '00:01',
           end: '23:59' }"
          ></el-time-select>
          <span class="heng2"></span>
          <el-time-select
            v-if="reviseDataobj.state==0"
            value-format="HH:mm:ss"
            @change="getDate3()"
            class="el_calendar2"
            v-model="value8"
            :picker-options="{     
           start: startT,
           step: '00:01',
           end: '23:59' }"
            placeholder="任意时间点"
          ></el-time-select>
          <el-time-select
            v-if="reviseDataobj.state==1"
            value-format="HH:mm:ss"
            @change="getDate3()"
            class="el_calendar2"
            v-model="value8"
            placeholder="任意时间点"
            :picker-options="{     
           start: '00:00',
           step: '00:01',
           end: '23:59' }"
          ></el-time-select>
        <p class="laber_p">可以手动输入时间</p>
        </div>
        <div class="button_box">
          <el-button type="primary" @click="cancel">取消</el-button>
          <el-button type="primary" @click="reviseData">确定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑功能的弹出框 -->
      <div :class="height?'twa_list_table2_box':'twa_list_table_box'">
        <table class="twa_list_table2">
          <thead>
            <tr>
              <td>日期</td>
              <td>签到时间</td>
              <td>状态</td>
              <td>签到人数</td>
              <td>签到率</td>
              <td>操作</td>
            </tr>
          </thead>
        </table>
      </div>
      <div class="twa_list">
        <table class="twa_list_table">
          
          <tbody >
            <tr v-for="(item,index) in tableData" v-if="listStatus"  :key="index">
              <td>{{item.date}}</td>
              <!-- <td></td> -->
              <td>{{item.time}}</td>
              <td>
                <span class="span_over" v-if="item.state==-1">
                  <img src="../../../../../../static/images/yiwancheng.png" />已结束
                </span>
                <span class="span_no_start" v-if="item.state==1">
                  <img src="../../../../../../static/images/weikaishi.png" />未开始
                </span>
                <span class="span_progress" v-if="item.state==0">
                  <img src="../../../../../../static/images/jinxingzhong.png" />进行中
                </span>
              </td>
              <td  v-if="item.state==1">
                --
              </td>
               <td  v-if="item.state!=1">
                <span class="table_num">{{item.attencePepleNum}}</span>
                /{{item.attenceAmountPepleNum}}
              </td>
              <td  v-if="item.state==1">
                --
              </td>
              <td v-if="item.state!=1">{{item.onceAttenceProbability}}%</td>
              <td v-if="item.state==-1">
                <el-button type="text" class="null_btn"></el-button>
                <!-- <el-button type="text" class="null_btn"></el-button> -->
                <el-button type="text" @click="viewDetail(item)">查看</el-button>
                 <el-button type="text" class="null_btn"></el-button>
                <!-- <el-button type="text" @click="open2(item)">删除</el-button> -->
              </td>
              <td v-if="item.state==1">
               
                <!-- <el-button type="text" class="null_btn"></el-button> -->
                <el-button type="text" @click="viewDetail(item)">查看</el-button>
                <el-button type="text" @click="revise(item,index)">编辑</el-button>
                <el-button type="text" @click="open2(item)">删除</el-button>
              </td>
              <td v-if="item.state==0">
                 <el-button type="text" class="null_btn"></el-button>
                <el-button type="text" @click="viewDetail(item)">查看</el-button>
                <el-button type="text" @click="revise(item,index)">编辑</el-button>
                <!-- <el-button type="text" @click="open2(item)">删除</el-button> -->
              </td>
            </tr>
            <tr  v-if="!listStatus">
                 <td  colspan="6" class="null_box">
                     
                    <img src='../../../../../../static/images/wujieguo.png'>
                    <p>暂无数据</p>
                
                 </td>
            </tr>
          </tbody>
        </table>
      </div>
       <el-pagination
          v-if="pageTotal.total>10"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageTotal.currentPage"
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageTotal.pageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next"
          :total="pageTotal.total"
          class="paginator"
        ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as api from "../../../../../api/workAttendanceApi";

export default {
  data() {
    return {
      classId: this.$route.query.classId | 0,
      courseId: this.$route.query.id || 0,
      dateFlag:new Date(),
      value1: "", //开始日期
      value2: "", //结束日期
      value3: "", //签到里面多选的日期
      value4: "07:30", //签到里开始时间
      value5: "18:30", //签到里结束时间
      value6: null, //下拉菜单的值
      value7: "", //编辑之后的时间 应该是 点击传进来的时间
      value8: "", //编辑之后的时间 应该是 点击传进来的时间
       value9: '', //签到的日期 因为改需求了 所有 4 5 作废了
       value10: '', //编辑的日期 因为改需求了 所有 4 5 作废了
      listStatus:false,
      height: window.innerHeight<768,
      DisableValue: "", //编辑之中的时间 这个是禁用的 应该是 点击传进来的时间
      clearable: false,
      activeNames: [],
      tableData: [], //这个是列表的数据
      tableData2: [], //这个是备份
      activeIndex: "1",
      activeIndex2: "1",
      menuTitle: "请选择状态",
      dialogTableVisible: false, //弹出框的状态
      dialogFormVisible: false, //弹出框的状态
      dialogTableVisible2: false, //弹出框的状态 签到
      dialogTableVisible3: false, //编辑弹出窗的 状态
      pageTotal: {
        //分页
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pageState : false, //用来控制page的翻页请求谁
      popoverFlag: false,
      activeName: "second", //查询 的选项卡
      options: [
        {
          value: -1,
          label: "已结束"
        },
        {
          value: 1,
          label: "未开始"
        },
        {
          value: 0,
          label: "进行中"
        }
      ],
      searchId: "", //查看里的搜索id 或者内容
      courseData: [],
      delData: {},
      viewDetailList: [],
      WorkAttendanceNum: {},
      viewDetailobj: {
        title: "",
        attenceAmountPepleNum: 0,
        attencePepleNum: 0
      },
      setTimeoutState: 1,
      reviseDataobj: {},
      reviseIndex: 0, //当前修改点击下标
      pickerOptions0: {
        disabledDate(time) {
          //8.64e7
          return time.getTime() < Date.now() - 8.64e7; //只能选择今天及今天之后
        }
      },
      startT: ``,
      endT: "",
      dateState: false //用来控制发起考勤的日期里是否有今日  有就是true  没有就是false
    };
  },
  
  mounted() {
    this.getList();
    //获取当前时间 然后 给 发起签到的时间选择器 加上当前时间之前不可使用
    let date2 = this.dateFlag;

    var h = date2.getHours();
    var m = date2.getMinutes();
    var s = date2.getSeconds();
    if (h <= 9) {
      h = "0" + h;
    }
    if (m <= 9) {
      m = "0" + m;
    }
    if (s <= 9) {
      s = "0" + h;
    }
    console.log(h, m);
    this.startT = `${h}:${m}`;
    console.log(this.startT);
    this.end = `23:59`;
    console.log(this.startT);
  },
  watch:{
    value9(val){
      if(val){
     this.value9[0] = val[0].slice(0,6)+'01'
     this.value9[1] = val[1].slice(0,6)+'59'
      }
    }
  },
   computed:{
     numTrue:function(){
       var num = 0 ;
       this.viewDetailList.forEach(v=>{
         if(v.chickIn){
           num++
         }
       })
       return num
     },
     numFalse:function(){   
      var num = 0 ;
       this.viewDetailList.forEach(v=>{
         if(!v.chickIn){
           num++
         }
       })
       return num
     },
   }
  ,
  methods: {
    handleChange(val) {
      console.log(val);
    },
    clickPush(){
     this.dateFlag = new Date()
     var date = new Date();
      var n = date.getFullYear();
      var y = date.getMonth() + 1;
      var r = date.getDate();
      if (y <= 9) {
        y = "0" + y;
      }
      if (r <= 9) {
        r = "0" + r;
      }
      var dateStr = n + "-" + y + "-" + r;
      
        this.dateState = true;
        this.value4 = this.startT;
        this.value5 = "22:30";
      
      var date2 = new Date()
      var month = parseInt(date2.getMonth() + 1)
      var day = date2.getDate()
      if (month < 10)  month = '0' + month
      if (day < 10)  day = '0' + day

      this.value3 = [date2.getFullYear() + '-' + month + '-' + day]
      this.dialogTableVisible2 = true
    },
    //获取时间  因为是两个单独的时间 所有用这个方法给他俩绑定一下
    getDate1() {
      //切割字符串 比大小
      let str1 = this.value1 ? this.value1 : 0;
      let str2 = this.value2 ? this.value2 : 0;
      let str3 = this.value1;
      if (str1 && str2 && str1 > str2) {
        this.value1 = this.value2;
        this.value2 = str3;
      }
    },
    getDate2() {
      let str1 = this.value4 ? this.value4 : 0;
      let str2 = this.value5 ? this.value5 : 0;
      let str3 = this.value4;
      if (str1 && str2 && str1 > str2) {
        this.value4 = this.value5;
        this.value5 = str3;
      }
    },
    getDate3() {
      let str1 = this.value7 ? this.value7 : 0;
      let str2 = this.value8 ? this.value8 : 0;
      let str3 = this.value7;
      if (str1 && str2 && str1 > str2) {
        this.value7 = this.value8;
        this.value8 = str3;
      }
    },
    stateChange(){
     this.queryList();
    },
    handleCommand(command) {},
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    // 选择状态的 点击事件
    handleSelect(key, keyPath) {
      this.menuTitle = key;
    },
    handleClick(tab, event) {
      //发起签到里的多个日期
    },
    getTwkDataList() {
      // 每次发起签到里的日期改变 判断里面是否有当前日期 如果就 就吧dateState变成true
      // 每次更改都会清空时间的数据
      var date = new Date();
      var n = date.getFullYear();
      var y = date.getMonth() + 1;
      var r = date.getDate();
      if (y <= 9) {
        y = "0" + y;
      }
      if (r <= 9) {
        r = "0" + r;
      }
      var dateStr = n + "-" + y + "-" + r;
       console.log(this.value3,dateStr)
      var dateState = this.value3.some(v => {
        return v == dateStr;
      });
      console.log(dateState)
      if (dateState) {
        this.dateState = true;
        this.value4 = this.startT;
        this.value5 = "22:30";
      } else {
        this.dateState = false;
        this.value4 = "7:30";
        this.value5 = "22:30";
      }
     

      let str = this.value3.toString();
    },
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      console.log(val)
      console.log(555)
      console.log(this.pageState)
      if(!this.pageState){
      let url = `/${this.courseId}/${this.classId}/${this.pageTotal.currentPage}/${this.pageTotal.pageSize}`;
      api.getWorkAttendanceList(url).then(res => {
        console.log(res)
        if(res.code==0&&res.data.list!=[]){
          if(res.data.list.length>0){
              this.tableData = res.data.list;
              this.pageTotal.total = res.data.total;
             
              this.tableData2 = JSON.parse(JSON.stringify(res.data.list));
              res.data.list.forEach((v, i) => {
                 var s = v.staAttenceDetail.startTime.split(" ");
                 var e = v.staAttenceDetail.endTime.split(" ");
    
                 this.tableData[i].date = `${s[0]}`;
                 this.tableData[i].time = `${s[1].slice(0,5)}-${e[1].slice(0,5)}`;
               
              });
                this.listStatus = true;
          }else{
             this.listStatus = false;
             this.pageTotal.total = 10;
          }
        }else{
          this.pageTotal.total = 10;
          return this.listStatus = false;
        }
        
      });
      }else{
      var data = {
        endTime: this.value2,
        startTime: this.value1,
        state: this.value6
      };
       let state 
       
       if (this.value6 ===0){
         state = 0
       }else if(this.value6){
        
         state = this.value6
       }else{
         state = 6
       }
        console.log("点击查询 根据条件获取数据 更新当前list");
        console.log(this.value1, this.value2, this.value6);
       let url = `/${this.courseId}/${this.classId}/${this.pageTotal.currentPage}/${this.pageTotal.pageSize}?endTime=${this.value2||0}&startTime=${this.value1||0}&state=${state}`;
        api.selectWorkAttendance(url).then(res => {
          if(res.code == 0){
            console.log(res.data)
             if(res.data.list.length>0){
                   this.tableData = res.data.list;
                   this.pageTotal.total = res.data.total;
                   res.data.list.forEach((v, i) => {
                   var s = v.staAttenceDetail.startTime.split(" ");
                   var e = v.staAttenceDetail.endTime.split(" ");
                   this.tableData[i].date = `${s[0]}`;
                   this.tableData[i].time = `${s[1].slice(0,5)}-${e[1].slice(0,5)}`;
                 });
                 this.listStatus = true;
             }else{
               this.pageTotal.total = 10;
                this.listStatus = false;
             }
          }else{
            this.pageTotal.total = 10;
            this.listStatus = false;
          }   
        });
      }
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.handleCurrentChange(1)
      console.log(111111)
    },
   
    addData() {
        // console.log(this.value9)
        // console.log(this.dateFlag.toString())
        
        var dateStr =this.dateFlag.toString().slice(16,24)
        if(this.dateState==true){
          // this.value9[0]
         
          if(this.value9[0]<dateStr){
               this.$message({
            type: "warning",
            message: "发起时间不能小于当前时间"
          });
           console.log(this.dateState)
          return
          }
          
        }
      
      //添加数据 如果两个都有值
      let date = new Date();
      // if (this.value3&&this.value4 && this.value5) {
        //让当前弹出框消失
        this.dialogTableVisible2 = false;
        //后台要的格式是大字符串
        var str = this.value3.toString();
        // 日期  开始时间 结束时间
        var data = {
          attence_time: str,
          startTime: this.value9[0],
          endTime: this.value9[1]
        };
        //地址/1/2
        let url = `/${this.courseId}/${this.classId}?attence_time=${str}&endTime=${this.value9[1]}&startTime=${this.value9[0]}`;
        //添加
        api.addWorkAttendance(url).then(res => {
          console.log(res);
          this.getList();
          if (res.code == 0) {
        
            this.$message({
              type: "success",
              message: "发起成功!"
            });
            this.value3 = ''
             
          }else{
            this.$message.error('考勤时间有重复插入失败');
          }
          
          
        });
        console.log("点击发起签到的确定 向后台发送数据 更新列表");
        // this.value3 = this.value4 = this.value5 = "";
      // } else {
      //    this.$message.error('条件不能有空值');
      // }

    },
    cancel() {
        this.dialogTableVisible3 = false;
        this.dialogTableVisible2 = false;
    },
    open() {
      console.log("点击查看 打开模态框 获取数据");
    },
    queryList() {
      this.pageState=true;
      var data = {
        endTime: this.value2,
        startTime: this.value1,
        state: this.value6
      };
       let state 
       console.log(this.value1+'------'+this.value2);
       if (this.value6 ===0){
         state = 0
       }else if(this.value6){
        
         state = this.value6
       }else{
         state = 6
       }
       console.log(!this.value1);
       console.log(!this.value2);
       console.log(!this.value2 || !this.value2);
       if((this.value1 == '' || this.value1 == null)&&(this.value2!=''&&this.value2!=null)){
       		this.$message.error('时间选择不全');
       		return
       }
       if((this.value2 == '' || this.value2 == null)&&(this.value1!=''&&this.value1!=null)){
       		this.$message.error('时间选择不全');
       		return
       }
        console.log("点击查询 根据条件获取数据 更新当前list");
        console.log(this.value1, this.value2, this.value6);
        let url = `/${this.courseId}/${this.classId}/1/${this.pageTotal.pageSize}?endTime=${this.value2||0}&startTime=${this.value1||0}&state=${state}`;
        api.selectWorkAttendance(url).then(res => {
          if(res.code == 0){
            console.log(res.data)
             if(res.data.list.length>0){
                   this.tableData = res.data.list;
                   this.pageTotal.total = res.data.total;
                   this.pageTotal.currentPage = 1;
                   res.data.list.forEach((v, i) => {
                   var s = v.staAttenceDetail.startTime.split(" ");
                   var e = v.staAttenceDetail.endTime.split(" ");
                   this.tableData[i].date = `${s[0]}`;
                   this.tableData[i].time = `${s[1].slice(0,5)}-${e[1].slice(0,5)}`;
                 });
                 this.listStatus = true;
             }else{
               this.pageTotal.total = 10;
                this.listStatus = false;
             }
          }else{
            this.pageTotal.total = 10;
            this.listStatus = false;
          }   
        });
     
    },
    getSearchList(e) {
      console.log(e)
     
      var _this = this;
      if (_this.setTimeoutState) {
        _this.setTimeoutState = 0;
        setTimeout(() => {
          console.log(11);
             
           if(this.searchId==''){
              let url = `?attenceDetailId=${this.viewDetailobj.attenceDetailId}&attenceId=${this.viewDetailobj.attenceId}`;
               api.selectWorkAttendanceViewDetail(url).then(res => {
             if(res.code == 0){
                console.log(res);
                this.viewDetailList = res.data;
                console.log(this.viewDetailList);
             }else{
               return
             }
            
             });
            
           }else{
             let url = `?attenceDetailId=${this.viewDetailobj.attenceDetailId}&attenceId=${this.viewDetailobj.attenceId}&stuNameOrNum=${this.searchId}`;
               api.selectWorkAttendanceViewDetailSearch(url).then(res => {
                 if(res.code==0){
                    console.log(res);
                    this.viewDetailList = res.data;
                 }      
               });
           }
         
          _this.setTimeoutState = 1;
        }, 1500);
      }

      // console.log(this.searchId);
    },
    open2(v) {
      console.log(v);
      this.delData = v;
      this.$confirm("此操作将永久删除该考勤, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let url = `/${this.courseId}/${this.classId}`;
          var obj = {
            attenceDetailId: v.staAttenceDetail.id,
            attenceId: v.staAttenceDetail.attenceId
          };
          api.delWorkAttendance(url, obj).then(res => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    revise(v, i) {
      this.dateFlag = new Date()
       let date2 = this.dateFlag;
       var h = date2.getHours();
       var m = date2.getMinutes();
       var s = date2.getSeconds();
       if (h <= 9) {
         h = "0" + h;
       }
       if (m <= 9) {
         m = "0" + m;
       }
       if (s <= 9) {
         s = "0" + h;
       }
       this.startT = `${h}:${m}`;
       this.end = `23:59`;   
       this.DisableValue  = v.date
       this.value7 = v.time.slice(0,5);
       this.value8 = v.time.slice(6,11);
       this.dialogTableVisible3 = true;
       this.reviseDataobj = v;
       this.reviseIndex = i;
    },
    reviseData() {
      if (
        (this.reviseDataobj.state == 1 && this.value7 == "") ||
        this.value8 == ""
      ) {
         this.$message.error('不能有时间为空');
        return;
      }
      var obj = this.tableData2[this.reviseIndex];
      let start = this.value7
        ? this.value7
        : this.reviseDataobj.time.slice(0, 8);
      let end = this.value8;
      console.log(end);
      let url = `/${this.courseId}/${this.classId}?date=${this.DisableValue}&endTime=${end}:59&startTime=${start}:01`;

      let data = {
        classAttenceListDto: obj
      };
      console.log(data);

      api.selectWorkAttendancereviseh(url, obj).then(res => {
        console.log(res);
        this.getList();
        if(res.code==0){
           this.$message({
              type: "success",
              message: "修改成功!"
            });
        }else{
          this.$message.error('签到时间冲突，无法保存！');
        }
      });
      this.dialogTableVisible3 = false;

    },

    getList() {
      this.pageState = false //用来控制page的翻页请求谁
      let url = `/${this.courseId}/${this.classId}/${this.pageTotal.currentPage}/${this.pageTotal.pageSize}`;
      api.getWorkAttendanceList(url).then(res => {
        console.log(res)
        if(res.code==0&&res.data.list!=[]){
          if(res.data.list.length>0){
              this.tableData = res.data.list;
              this.pageTotal.total = res.data.total;
             
              this.tableData2 = JSON.parse(JSON.stringify(res.data.list));
              res.data.list.forEach((v, i) => {
                 var s = v.staAttenceDetail.startTime.split(" ");
                 var e = v.staAttenceDetail.endTime.split(" ");
    
                 this.tableData[i].date = `${s[0]}`;
                 this.tableData[i].time = `${s[1].slice(0,5)}-${e[1].slice(0,5)}`;
               
              });
                this.listStatus = true;
          }else{
             this.listStatus = false;
          }
        }else{
          return this.listStatus = false;
        }
        
      });

      let url2 = `/${this.courseId}/${this.classId}`;
      api.getWorkAttendanceCountNum(url2).then(res => {
        console.log(res);
        this.WorkAttendanceNum = res.data;
      });
      console.log(this.classId);
      console.log(this.courseId);
    },
    viewDetail(v) {
      console.log(v);
      this.searchId = ''
      this.viewDetailobj = {
        title: v.date,
        attenceAmountPepleNum: v.attenceAmountPepleNum,
        attencePepleNum: v.attencePepleNum,
        attenceId: v.staAttenceDetail.attenceId,
        attenceDetailId: v.staAttenceDetail.id
      };
      console.log(this.viewDetailobj);
      this.dialogTableVisible = true;

      let url = `?attenceDetailId=${v.staAttenceDetail.id}&attenceId=${v.staAttenceDetail.attenceId}`;
      api.selectWorkAttendanceViewDetail(url).then(res => {
        if(res.code == 0){
           console.log(res);
           this.viewDetailList = res.data;
           console.log(this.viewDetailList);
        }else{
          return
        }
       
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  background-color: rgba(244, 244, 244, 1);

  height: 100%;
}
.teacherworkattendance_box {
  // min-width: 1296px;
  // width: 85%;
  padding: 14px 24px 0 24px;
  height: calc(100% - 16px);
  // margin: 16px 16px 32px 16px;
  background-color: #ffffff;

  ::placeholder {
    color: rgba(153, 153, 153, 1);
    font-size: 12px !important;
  }
  /deep/ .el-input__prefix{
     display: none;
  }

  .twa_num {
    display: flex;
    justify-content: space-between;
    line-height: 48px;
    font-size: 16px;
    font-weight: bold;
    span {
      color: rgba(83, 151, 247, 1);
      margin-left: 12px;
    }
    .twa_num_l {
      display: flex;
      justify-content: space-between;
      width: 744px;
      div {
        // display: flex;
        justify-content: space-around;
        width: 120px;
      }
    }
    .twa_num_r {
      width: 191px;
      margin-right: 19px;
      div {
        // display: flex;
        justify-content: space-around;
        width: 191px;
      }
    }
  }
  .twa_list_table2_box{
    padding-right: 6px;
  }
  .twa_list_table2_box2{
    padding-right: 0;
  }
  .twa_list_table2 {
      
      width: 100%;
       margin-top: 21px;
      text-align: center;
      font-size: 12px;
      border: 1px solid rgba(226, 226, 226, 1);    
      tr {
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(226, 226, 226, 1);
      }
      thead {
        background-color: rgba(83, 151, 247, 0.1);
         td:nth-child(2n) {
          background-color: rgba(83, 151, 247, 0.05);
        }
        td {
          width: 16.6%;
        }
         tr > td:nth-last-child(1) {
          width: 18.4%;
        }
      }  
  }
  .twa_list {
    width: 100%;
    height: calc(100% - 220px);
    max-height: 480px;
    overflow: auto;
    .twa_list_table {
      width: 100%;
      margin: 0;
      text-align: center;
      font-size: 12px;
      border: 1px solid rgba(226, 226, 226, 1);
      
      tr {
        height: 40px;
        border: 1px solid rgba(226, 226, 226, 1);
      }
      thead {
        background-color: rgba(83, 151, 247, 0.1);
      }
      /deep/ .el-button {
        margin: 0;
        padding: 0;
      }
      tbody {
        td:nth-child(2n) {
          background-color: rgba(83, 151, 247, 0.05);
        }
        td {
          width: 16.6%;
        }
        tr > td:nth-last-child(1) {
          width: 18.4%;
        }

        .table_num {
          color: red;
        }

        button {
          width: 56px;
          height: 24px;
          border: 1px solid rgba(228, 232, 241, 1);
          border-radius: 12px;
          font-size: 10px;
          font-weight: 400;
          line-height: 24px;
          color: rgba(83, 151, 247, 1);
          // background:white !important;
        }
        .null_btn {
          border: 0;
          cursor: default;
        }
      }
      .null_tr{
        text-align: center;
        height: 800px;
      }
    }
  }
  /deep/ .el-dialog {
    width: 543px;
    height: 453px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 8px;
  }
  /deep/ .el-dialog__header {
    width: 499px;
    margin: 0;
    padding: 0 22px;
    height: 48px;
    background: rgba(83, 151, 247, 1);
    line-height: 48px;
    opacity: 1;
    border-radius: 8px 8px 0px 0px;
    span {
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
    }
    .el-dialog__close {
      color: white;
    }
  }
  /deep/ .dialog_1 {
    .el-dialog__body {
      padding: 10px 32px 48px 32px;
      li {
        display: flex;
        justify-content: space-between;
        text-align: center;
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(230, 230, 230, 1);
        border-radius: 4px 4px 0px 0px;
        span {
          flex: 1.1;
        }
        .span_r {
          text-align: left;
          flex: 0.9;
        }
      }
      .dialog_1_ul_li {
        background: rgba(83, 151, 247, 0.1);

        color: rgba(153, 153, 153, 1);
        span {
          flex: 1.1;
        }
        .span_r {
          text-align: left;
          flex: 0.9;
        }
      }
    }

    button:nth-child(1) {
      margin-left: 89px;
      width: 311px;
      height: 51px;
      margin-bottom: 34px;
      line-height: 25.5px;
      background: rgba(83, 151, 247, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
      opacity: 1;
      font-size: 12px;
      border-radius: 4px;

      span {
        font-size: 32px;
      }
      i {
        font-size: 12px;
      }
    }
  }

  /deep/ .el-menu-demo_1 {
    position: relative;
    width: 180px;
    height: 30px;
    margin-left: 16px;
    opacity: 1;
    border-radius: 4px;
    /deep/ .el-menu--popup {
      width: 180px;
      padding: 0;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: 0;
    }

    /deep/ .el-submenu__title {
      width: 180px;
      height: 32px !important;
      line-height: 32px !important;
      border: 1px solid rgba(226, 226, 226, 1);
      opacity: 1;
      border-radius: 4px;
      i {
        position: absolute;
        right: 12px;
      }
    }
  }
  /deep/ .dialog_2 {
    .el-dialog__body {
      padding: 27px 35px 0 34px;
      width: 474px;
      height: 406px;
      background: rgba(255, 255, 255, 1);
      opacity: 1;
      border-radius: 8px;
    }
    .el-dialog__header {
      width: 499px;
      margin: 0;
      padding: 0 22px;
      height: 48px;
      background: rgba(83, 151, 247, 1);
      line-height: 48px;
      opacity: 1;
      border-radius: 8px 8px 0px 0px;
    }
    .laber_box {
      width: 100%;
      height: 34px;
      line-height: 34px;
      margin-bottom: 16px;
      label {
        display: inline-block;
        width: 58px;
        text-align: right;
        margin-right: 8px;
        font-size: 14px;
      }
      span {
        margin: 0px 9px 0 18px;
      }
      .el-input__inner {
        height: 36px;
      }
      .laber_box_date {
        width: 400px;
        height: 34px;
        opacity: 1;
        border-radius: 4px;
        span {
          display: none;
        }
        #date {
          background: url("../../../../../../static/images/date.png") no-repeat;
          background-position: 368px 10px;
          width:350px;
        }
      }
      // input {
      //   width: 180px;
      //   background: url("../../../../../../static/images/sanjiao.png") no-repeat;
      //   background-position: 162px 13px;
      // }
      .el_calendar1 {
        width: 150px;
        height: 34px;
        opacity: 1;
        border-radius: 4px;
        span {
          display: none;
        }
      }
      .el_calendar2 {
        width: 150px;
        height: 34px;
        opacity: 1;
        border-radius: 4px;
        span {
          display: none;
        }
      }
    }
    .button_box {
      width: 226px;
      margin-top: 188px;
      margin-left: 147px;
      button {
        width: 96px;
        height: 34px;
        color: white;
        font-size: 14px;
        line-height: 12px;
      }
      & > :nth-child(1) {
        background: rgba(185, 214, 255, 1);
      }
      & > :nth-child(2) {
        background: rgba(83, 151, 247, 1);
        margin-left: 24px;
      }
    }
  }
  .search {
    position: absolute;
    z-index: 999;
    left: 271px;
    padding-left: 42px;
    top: 139px;
    width: 198px;
    height: 30px;
    border: 1px solid rgba(226, 226, 226, 1);
    opacity: 1;
    border-radius: 4px;
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 30px;
    background: url("../../../../../../static/images/dccheck.png") no-repeat;
    background-position: 16px 7px;
    background-size: 14px 14px;
  
  }
  .sarch_ul{
    height: 200px;
    overflow-y: auto;
  }
  .heng {
    display: inline-block;
    position: relative;
    top: -5px;
    width: 16px;
    height: 1px;
    background: rgba(153, 153, 153, 1);
    opacity: 1;
    border-radius: 8px;
  }
  .heng2 {
    position: relative;
    top: -5px;
    display: inline-block;
    width: 16px;
    height: 4px;
    background: rgba(153, 153, 153, 1);
    opacity: 1;
    border-radius: 8px;
  }
  /deep/ .select1 {
    margin-left: 1.2%;
    height: 30px;
    .el-input__inner {
      height: 30px;
    }
    .el-select__caret {
      height: 40px;
      margin-top: -5px;
    }
    input {
      width: 180px;
    //   background: url("../../../../../../static/images/sanjiao.png") no-repeat;
      // background-position: 162px 13px;
    }
    // span {
    //   display: none;
    // }
  }

  .span_over {
    color: rgba(83, 151, 247, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 20px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
  .span_no_start {
    color: rgba(255, 120, 90, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 20px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
  .span_progress {
    color: rgba(255, 178, 60, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 20px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
  .search_box {
    width: 100%;
    height: 36px;
    padding: 8px 0;
    border-bottom: 1px solid rgba(83, 151, 247, 1);
    position: relative;
    .calendar_search_auto {
      width: 1334px;
      position: absolute;
      right: 0;
      height: 36px;

      .picker {
        display: inline-block;
        margin-left: 674px;
        .el-date-editor.el-input {
          width: 115px !important;
        }
        /deep/ .el-input__inner {
          
          width: 115px;
          height: 36px;
          padding: 7px 0px 7px 12px;
          background: url("../../../../../../static/images/date.png") no-repeat;
          background-position: 91px 8px;
        }
       /deep/ .el-input__suffix{
         position: absolute;
         top:4px;
         line-height: 12px;
          margin-top: -3px;
          height: 26px;
          background: white;
        
        }
        /deep/ .el-input__prefix {
          display: none;
        }
      }
    }
    .btn_work_attendance,
    .btn_search {
      // line-height: 1;
      // border: 1px solid rgba(83, 151, 247, 1);
      padding-top:7px ;
      border-radius: 4px;
      color: rgba(83, 151, 247, 1);
      // background: white;
    }

    .btn_search {
      width: 72px;
      height: 30px;
      margin-left: 16px;
    }
    .btn_work_attendance {
      width: 90px;
      height: 30px;
      margin-left: 12px;
    }
  }
  .pagintaion_box {
    overflow: auto;
    zoom: 1;
    & > div {
      float: right;
      margin-right: 25px;
    }
    margin-top: 15%;
    /deep/ .el-input {
      margin-top: -5px;
    }
  }
  /deep/ .dialog_3 {
    @extend .dialog_2;
  }
}
.null_box{
    padding-top: 100px;
    height: 360px;
    text-align: center;
    p{
      color: #999999;
    }
    img{
      margin: 0 auto;
    }
    
  }
  .laber_p{
    margin-left:80px;
    font-size: 10px;
    // color: rgba(247, 247, 247, 0.185);
    color: rgba(0, 0, 0, 0.34);
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/workAttendance/teacherWorkAttendance.vue